import React from 'react';
import './Legal.css';

export default function Terms({ navigate }) {
  return (
    <div className="legal-page">
      <div className="page-banner">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p>Last updated: November 2021</p>
        </div>
      </div>
      <section className="legal-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-intro">
              <p>By downloading and using the HiveeClub application, you agree to be bound by these Terms and Conditions. Please read them carefully before using our platform.</p>
            </div>

            {[
              {
                title: '1. Acceptance of Terms',
                content: `By creating an account and using HiveeClub, you confirm that you are at least 18 years of age and agree to these Terms and Conditions. If you do not agree to these terms, please do not use our platform.`
              },
              {
                title: '2. User Accounts',
                content: `You are responsible for maintaining the confidentiality of your account credentials. You agree to:\n\n• Provide accurate and complete information when creating your account\n• Keep your login credentials secure and not share them with others\n• Notify us immediately of any unauthorised use of your account\n• Be responsible for all activities conducted through your account`
              },
              {
                title: '3. Ticket and Table Bookings',
                content: `When booking tickets or VIP tables through HiveeClub:\n\n• All bookings are subject to availability\n• Prices displayed are inclusive of applicable fees unless otherwise stated\n• A QR code will be generated upon successful booking for venue entry\n• Bookings are non-transferable unless explicitly permitted by the event organiser\n• HiveeClub acts as a platform facilitating bookings; the venue operator is responsible for the event itself`
              },
              {
                title: '4. Cancellations and Refunds',
                content: `Refund policies vary by event and venue. Please review the specific refund terms displayed during booking. Generally:\n\n• Cancellations made more than 48 hours before the event may be eligible for a refund\n• Cancellations made less than 48 hours before the event are generally non-refundable\n• HiveeClub reserves the right to cancel events and will provide appropriate refunds in such cases\n• Processing fees may be non-refundable`
              },
              {
                title: '5. HiveeClub Rewards Program',
                content: `The HiveeClub Rewards program is subject to these Terms and Conditions:\n\n• Points have no cash value and cannot be exchanged for cash\n• Rewards are subject to availability and may be modified or discontinued at any time\n• Tier status is based on accumulated spend within a 12-month period\n• You cannot redeem more than 10 tickets for the same event\n• Rewards cannot be returned or exchanged once redeemed\n• HiveeClub reserves the right to adjust, suspend, or terminate the Rewards program`
              },
              {
                title: '6. Social Features',
                content: `HiveeClub provides social networking features including group chats and private messaging. You agree to:\n\n• Not post content that is unlawful, defamatory, abusive, or violates any third-party rights\n• Not engage in spamming, harassment, or any behaviour that negatively impacts other users\n• Respect the privacy of other users\n• Not use the platform for commercial solicitation without prior written consent\n\nHiveeClub reserves the right to remove any content and suspend or terminate accounts that violate these standards.`
              },
              {
                title: '7. Prohibited Activities',
                content: `You agree not to:\n\n• Attempt to gain unauthorised access to our systems or other users' accounts\n• Use automated bots or scripts to interact with the platform\n• Resell or scalp tickets purchased through HiveeClub\n• Misrepresent your identity or impersonate any person\n• Engage in any activity that disrupts or interferes with the platform's functionality`
              },
              {
                title: '8. Intellectual Property',
                content: `All content, trademarks, logos, and intellectual property displayed on HiveeClub are owned by or licensed to HiveeClub. You may not use, reproduce, or distribute any HiveeClub content without prior written permission.`
              },
              {
                title: '9. Limitation of Liability',
                content: `To the maximum extent permitted by law, HiveeClub shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the platform, including but not limited to loss of data, loss of profits, or business interruption.`
              },
              {
                title: '10. Governing Law',
                content: `These Terms and Conditions are governed by the laws of Australia. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Australia.`
              },
              {
                title: '11. Contact Us',
                content: `For any questions regarding these Terms and Conditions, please contact us at:\n\nEmail: info@hivee.app\nHiveeClub — Australia`
              },
            ].map(section => (
              <div key={section.title} className="legal-block">
                <h2>{section.title}</h2>
                {section.content.split('\n').map((line, i) => (
                  <p key={i}>{line || '\u00A0'}</p>
                ))}
              </div>
            ))}

            <div className="legal-footer-cta">
              <p>Have questions about our terms?</p>
              <button className="btn-primary" onClick={() => navigate('contact')}>Contact Us →</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
